import homeicuimg from "../../Assets/home-icu-img.png"
import wecover1 from "../../Assets/wecover1.png"
import wecover2 from "../../Assets/wecover2.png"
import wecover3 from "../../Assets/wecover3.png"
import wecover4 from "../../Assets/wecover4.png"
import wecover5 from "../../Assets/wecover5.png"
import wecover6 from "../../Assets/wecover6.png"
import wecover7 from "../../Assets/wecover7.png"
import wecover8 from "../../Assets/wecover8.png"
import supportyour1 from "../../Assets/supportyour1.png"
import supportyour2 from "../../Assets/supportyour2.png"
import supportyour3 from "../../Assets/supportyour3.png"
import supportyour4 from "../../Assets/supportyour4.png"
import supportyour5 from "../../Assets/supportyour5.png"
import supportyour6 from "../../Assets/supportyour6.png"
import criticalneedimg from "../../Assets/criticalneedimg.png"
import prakash from "../../Assets/prakash.png"
import mansi from "../../Assets/mansi.png"
import snigdha from "../../Assets/snigdha.png" 
import adithyaLogo from "../../Assets/hs1.png"
import kamalaLogo from "../../Assets/hs2.png"
import novacareLogo from "../../Assets/hs3.png"


export const serviceShowcaseData = [
    {
        imgSrc: homeicuimg,
        title: `Transforming the\n ICU experience From\n hospital rooms to\n home comforts`,
        buttonText: "Book Now",
        onButtonClick: () => console.log("Button Clicked"),
    },
];

export const heading1 = "No Hospital Beds, No Sterile Rooms";
export const paragraph1 = `Transforming healthcare with our innovative home ICU setup. Say goodbye to hospital stays and hello to comfort, convenience, 
and expert care tailored to your needs. Stay connected to loved ones, minimize the risk of hospital-acquired infections, 
and enjoy the comfort of your home while receiving expert medical attention.`


export const cardsheading = `We Cover`
export const homeicuservices = {

    o1: { title: "Skilled Nursing Care", img: wecover1 },
    o2: { title: "Vital Monitoring", img: wecover2 },
    o3: { title: "IV Administration", img: wecover3 },
    o4: { title: "Catheter Care", img: wecover4 },
    o5: { title: "Infection Control", img: wecover5 },
    o6: { title: "Equipment Handling", img: wecover6 },
    o7: { title: "Doctor Consultation", img: wecover7 },
    o8: { title: "Ventilator Support", img: wecover8 },
};

//card slider data
export const suportyourjourney = {
    a1: { title: "Critically Ill", img: supportyour1 },
    a2: { title: "Post Surgery Recovery", img: supportyour2 },
    a3: { title: "Organ Failure", img: supportyour3 },
    a4: { title: "Cancer Care", img: supportyour4 },
    a5: { title: "Multiple Trauma", img: supportyour5 },
    a6: { title: "Post – Transplant", img: supportyour6 },
};

export const criticalneed_data = {
    title: `Is Medical ICU Set Up A Critical Need?`,
     para1: `With the rise of complex medical conditions and the growing demand for personalized care, medical ICU setups have emerged as essential components of modern healthcare infrastructure.`,
    para2: `It ensures that patients receive timely interventions, continuity of care, and access to the latest medical advancements.`,
    para3: `Plays a crucial role in relieving pressure on traditional hospital ICUs, which may be overcrowded or facing resource constraints.`,
    image: criticalneedimg
}

export const homeicu_testimonials = [
    {
        title: `Don’t Just Take Our Word For It`,
        desc: `I was hesitant about receiving ICU-level care at home, but it turned out
to be the best decision. The wihan home icu setup was comprehensive,
the nurses were skilled, and I was able to heal in the comfort of my own
space. I highly recommend it.`,
        userimg: mansi,
        username: "Mrudula Joshi"
    },
    {
        title: `Don’t Just Take Our Word For It`,
        desc: `The Home ICU setup services from wihan made a world of difference for
our family. The personalized care and attention to detail ensured that my
mother received the best possible treatment while staying at home.
We're forever grateful.`,
        userimg: prakash,
        username: "Prakash Kumar"
    },
    {
        title: `Don’t Just Take Our Word For It`,
        desc: `I was impressed by the level of care and attention to detail during my 
home diagnostic test. The staffs at wihan were very professional, and
the results were delivered promptly.`,
        userimg: snigdha,
        username: "Snigdha Reddy"
    },
]

export const sliderdata = [
     { name: 'SHRI ADITHYA Hospitals', logo: adithyaLogo },
  { name: 'SRESHTA SRI KAMALA HOSPITALS', logo: kamalaLogo },
  { name: 'NOVACARE HOSPITALS', logo: novacareLogo },
];

export const settings3 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: { slidesToShow: 3 }
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 3 }
        },
        {
            breakpoint: 480,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 380,
            settings: { slidesToShow: 1 }
        }
    ]
};